const AboutStyles = () => {
  return (
    <style jsx>{`
      .about-page {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
          sans-serif;
        overflow-x: hidden;
      }

      .min-vh-85 {
        min-height: 85vh;
      }

      .section-header {
        margin-bottom: 60px;
      }

      /* Different Section */
      .different-section .row {
        row-gap: 24px;
      }

      /* Tech Stack Section */
      .tech-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 24px;
        margin-top: 40px;
      }

      @media (max-width: 768px) {
        .tech-grid {
          grid-template-columns: 1fr;
        }
      }

      .tech-card {
        background: white;
        border: 1px solid rgba(10, 36, 88, 0.1);
        border-radius: 16px;
        overflow: hidden;
        transition: all 0.3s ease;
      }

      .tech-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 30px rgba(10, 36, 88, 0.1);
      }

      .tech-card-header {
        padding: 20px;
        background: rgba(10, 36, 88, 0.05);
        border-bottom: 1px solid rgba(10, 36, 88, 0.1);
      }

      .tech-card-body {
        padding: 20px;
      }

      .tech-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 0;
      }

      .tech-dot {
        width: 8px;
        height: 8px;
        background: #0a2458;
        border-radius: 50%;
        flex-shrink: 0;
      }

      /* How We Work Section */
      .process-steps {
        display: flex;
        flex-direction: column;
        gap: 60px;
      }

      .process-step {
        display: flex;
        flex-direction: column;
        gap: 24px;
      }

      .step-header {
        display: flex;
        align-items: center;
        gap: 20px;
      }

      .step-number {
        width: 60px;
        height: 60px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: 700;
      }

      .step-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 40px;
        align-items: center;
      }

      /* Step 2: Text left, image right */
      .process-step:nth-child(2) .step-image {
        order: 2;
      }
      .process-step:nth-child(2) .step-description {
        order: 1;
      }

      .process-step:nth-child(2) .step-header {
        align-self: flex-end;     /* header ko right side le jao */
        width: 50%;               /* same width as image column */
      }

      @media (max-width: 992px) {
        .step-content {
          grid-template-columns: 1fr;
        }

        .process-step:nth-child(2) .step-header {
          align-self: flex-start;
          width: 100%;
        }
      }

       .step-image,
  .step-description {
    order: unset;
  }

      .step-image img {
        width: 100%;
        height: auto;
        max-height: 400px;
        object-fit: cover;
      }

      /* Beliefs Section */
      .beliefs-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 30px;
      }

      .belief-card {
        background: rgba(10, 36, 88, 0.02);
        border: 1px solid rgba(10, 36, 88, 0.1);
        border-radius: 16px;
        padding: 30px;
        text-align: center;
        transition: all 0.3s ease;
      }

      .belief-card:hover {
        transform: translateY(-5px);
        background: white;
        box-shadow: 0 15px 30px rgba(10, 36, 88, 0.1);
      }

      .belief-icon {
        font-size: 48px;
        margin-bottom: 20px;
      }

      /* Industries Section */
      .industries-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 30px;
        margin-bottom: 60px;
      }
.founder-image {
  height: 480px;
  width: 100%;
  object-fit: cover;
  object-position: center top;   /* 👈 yahin magic */
  border-radius: 20px;
}


      .industry-card {
        background: white;
        border: 1px solid rgba(10, 36, 88, 0.1);
        border-radius: 16px;
        padding: 30px;
        text-align: center;
        transition: all 0.3s ease;
      }

      .industry-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 15px 30px rgba(10, 36, 88, 0.1);
        border-color: #0a2458;
      }

      .industry-icon {
        font-size: 48px;
        margin-bottom: 20px;
      }

      /* International Section */
      .country-badge {
        background: rgba(10, 36, 88, 0.1);
        color: #0a2458;
        padding: 8px 20px;
        border-radius: 50px;
        font-weight: 600;
        font-size: 14px;
        transition: all 0.3s ease;
      }

      .country-badge:hover {
        background: #0a2458;
        color: white;
        transform: translateY(-2px);
      }

      /* Founder Section */
      .founder-image-container {
        position: relative;
        padding: 10px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 20px;
        backdrop-filter: blur(10px);
      }

      .founder-content {
        background: rgba(255, 255, 255, 0.05);
        padding: 30px;
        border-radius: 16px;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.1);
      }

      /* Why Choose Section */
      .reasons-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 30px;
      }

      .reason-card {
        display: flex;
        align-items: flex-start;
        gap: 20px;
        padding: 25px;
        background: rgba(10, 36, 88, 0.02);
        border: 1px solid rgba(10, 36, 88, 0.1);
        border-radius: 16px;
        transition: all 0.3s ease;
      }

      .reason-card:hover {
        transform: translateY(-5px);
        background: white;
        box-shadow: 0 15px 30px rgba(10, 36, 88, 0.1);
        border-color: #0a2458;
      }

      .reason-check {
        width: 40px;
        height: 40px;
        background: #10b981;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 20px;
        flex-shrink: 0;
      }

      /* Animations */
      @keyframes bounce {
        0%,
        20%,
        50%,
        80%,
        100% {
          transform: translateY(0) translateX(-50%);
        }
        40% {
          transform: translateY(-10px) translateX(-50%);
        }
        60% {
          transform: translateY(-5px) translateX(-50%);
        }
      }

      @keyframes slideIn {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .different-section,
      .tech-stack-section,
      .how-we-work-section,
      .beliefs-section,
      .industries-section,
      .international-section,
      .founder-section,
      .why-choose-section {
        animation: slideIn 0.6s ease;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .display-3 {
          font-size: 2.5rem !important;
        }

        .min-vh-85 {
          min-height: auto;
          padding: 60px 0;
        }

        .process-step {
          gap: 20px;
        }

        .step-header {
          flex-direction: column;
          text-align: center;
          gap: 10px;
        }

        .founder-section .row {
          flex-direction: column;
        }

        .founder-section .col-lg-8 {
          padding-top: 30px;
        }
      }

      /* Global improvements */
      * {
        box-sizing: border-box;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        line-height: 1.3;
        margin-top: 0;
      }

      p {
        line-height: 1.6;
        margin-top: 0;
      }

      .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
      }
    `}</style>
  );
};
export default AboutStyles;
